// extracted by mini-css-extract-plugin
module.exports = {"remoteVideo":"LiveStreamRemoteVideo_remoteVideo__c8xy3"};